import { Retriever, IState, IMessageBus } from "../../../../common";
import { SportModel, sportDictionary, itemIDs } from "../..";
import { InternalMessageBusChannels } from "sb-resp-lib";

type cookies = {
    get(name: string): string | undefined
}

export class FavoritesRetriever extends Retriever<SportModel> {
    private readonly favoriteItemId: string = itemIDs.favorites;
    private readonly messageBus: IMessageBus;
    private readonly isFavoritesFirst: boolean;
    private readonly dict: sportDictionary;
    private readonly cookieName: string;
    private readonly cookies: cookies;

    private addFavoritesSubscription: () => void;
    private removeFavoritesSubscription: () => void;

    constructor (messageBus: IMessageBus, isFavoritesFirst: boolean, blockId: string, dict: sportDictionary, cookies: cookies) {
        super();
        this.cookieName = `favoriteEvents_${blockId}`;
        this.messageBus = messageBus;
        this.isFavoritesFirst = isFavoritesFirst;
        this.dict = dict;
        this.cookies = cookies;
        this.addFavoritesSubscription = () => {};
        this.removeFavoritesSubscription = () => {};
    }

    async activate(state: IState<SportModel>) {
        const count = this.getFavoriteEventsCountFromCookie();
        if (count > 0) {
            state.add(this.getFavoritesItem(count));
        }
        this.addFavoritesSubscription = this.messageBus.getSubscription(InternalMessageBusChannels.favoriteEvents.add, () => this.addFavorites(state), this);
        this.removeFavoritesSubscription = this.messageBus.getSubscription(InternalMessageBusChannels.favoriteEvents.remove, () => this.removeFavorites(state), this);
    }

    private getFavoritesItem(count:number) : SportModel {
        return new SportModel({
            id: this.favoriteItemId,
            name: this.dict.favorites,
            numberOfEvents: count,
            order: this.isFavoritesFirst ? -3 : 1000
        }, "favorites");
    }

    private getFavoriteEventsCountFromCookie() {
        const selectedEvents = this.cookies.get(this.cookieName);
        return selectedEvents ?  selectedEvents.split(",").length : 0;
    }

    private addFavorites(state: IState<SportModel>)
    {
        const favoritesItem = state.getItemById(this.favoriteItemId);
        if (favoritesItem) {
            state.update(this.favoriteItemId, { numberOfEvents: favoritesItem.numberOfEvents + 1 }, true);
        } else {
            state.add(this.getFavoritesItem(1));
        }
    }

    private removeFavorites(state: IState<SportModel>) {
        const favoritesItem = state.getItemById(this.favoriteItemId);
        if (favoritesItem) {
            const newCount = favoritesItem.numberOfEvents - 1;
            if (newCount) {
                state.update(this.favoriteItemId, { numberOfEvents: newCount }, true);
            } else {
                state.remove(this.favoriteItemId, true);
            }
        }
    }

    deactivate() {
        this.addFavoritesSubscription();
        this.removeFavoritesSubscription();
    }
}
